export const AUDIOBOOKS_ENABLED = 'web.audiobooks.enabled';
